export class NebisTalepBilgiler {
    id:number=0;
    aciklama:string='';
    bitisTarihi: Date = new Date();
    kayitTarihi: Date = new Date();
    sonGuncellemeTarihi: Date = new Date();
    sms:boolean=false;
    eposta:boolean=false;
    dosya:string='';
    kapatildimi:number=0;
    olumlumu:number=0;
    durumAdi:string='';
    birimAdi:string='';
    talepKategoriAdi:string='';
    yapilanSonIslem:string='';
    hareketBilgileri: any[] = [];
    localKullaniciTalepId:number=0;
}